module.exports = __webpack_public_path__ + "55ed4d1fa89595ae59b9ecc8ba97ced2.png";